import { render, staticRenderFns } from "./ProjectDetailView.vue?vue&type=template&id=06f94ce6&scoped=true&"
import script from "./ProjectDetailView.vue?vue&type=script&lang=js&"
export * from "./ProjectDetailView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDetailView.vue?vue&type=style&index=0&id=06f94ce6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f94ce6",
  null
  
)

export default component.exports